import React from 'react';
import useFadeIn from '../hooks/useFadeIn';

export default function Hero() {
  const [ref, visible] = useFadeIn(0.05);

  const scrollToWaitlist = () =>
    document.getElementById('waitlist-cta')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="hero" aria-label="Hero">
      {/* Left — headline */}
      <div ref={ref} className={`hero-left fade-up ${visible ? 'visible' : ''}`}>
        <div className="hero-badge">
          <span className="hero-badge-dot" aria-hidden="true" />
          Launching Soon
        </div>

        <h1>
          Every signature<br />
          backed by <em>proof.</em>
        </h1>

        <div className="hero-rule" aria-hidden="true" />

        <p className="hero-sub">Sign · Verify · Prove</p>

        <p className="hero-desc">
          Digital document execution built for India — combining signing,
          identity verification, and evidence into a single workflow.
        </p>

        <button className="hero-cta-btn" onClick={scrollToWaitlist}>
          Request Early Access
        </button>
      </div>

      {/* Right — icon + stats */}
      <div className="hero-right" aria-hidden="true">
        <img src="/logo-icon.png" alt="" className="hero-icon" />
        <div className="hero-stats">
          <div className="hero-stat">
            <div className="hero-stat-num">5+</div>
            <div className="hero-stat-label">Signing methods</div>
          </div>
          <div className="hero-stat">
            <div className="hero-stat-num">100%</div>
            <div className="hero-stat-label">Evidence backed</div>
          </div>
          <div className="hero-stat">
            <div className="hero-stat-num">IT Act</div>
            <div className="hero-stat-label">Compliant</div>
          </div>
        </div>
      </div>
    </section>
  );
}
